<div class="row mb-3">
    <div class="col-md-12">
        <h5 class="fishery-section">{{ title }}</h5>
    </div>
    <div class="col-md-12 mb-2 mt-2" *ngIf="description">
        <fi-template-renderer [template]="description"></fi-template-renderer>
    </div>
    <div class="col-md-12">
        <ng-container *ngIf="items.length <= 5">
            <ul>
                <li *ngFor="let values of items">

                    <a *ngIf="values.alphaCode" target="_blank" href="{{ fisheryUrl + link + getAlphaCode(values.alphaCode) }}">
                        <i>{{ values.scientificName || values.value }}</i>
                    </a>
                    <i *ngIf="!values.alphaCode">{{ values.scientificName || values.value }}</i>
                    <label class="alphaCode" *ngIf="values.alphaCode">&nbsp;({{ alphaCodeLabel + ": " + values.alphaCode + "; " + values.name }})</label>

                </li>
            </ul>
        </ng-container>
        <ng-container *ngIf="items.length > 5">
            <ul>
                <li *ngFor="let values of items.slice(0,5)">

                    <a *ngIf="values.alphaCode" target="_blank" href="{{ fisheryUrl + link + getAlphaCode(values.alphaCode) }}">
                        <i>{{ values.scientificName || values.value }}</i>
                    </a>
                    <i *ngIf="!values.alphaCode">{{ values.scientificName || values.value }}</i>
                    <label class="alphaCode" *ngIf="values.alphaCode">&nbsp;({{ alphaCodeLabel + ": " + values.alphaCode + "; " + values.name }})</label>
                
                </li>
            </ul>
            <ng-container *ngIf="showMore">
                <ul>
                    <li *ngFor="let values of items.slice(5)">

                        <a *ngIf="values.alphaCode" target="_blank" href="{{ fisheryUrl + link + getAlphaCode(values.alphaCode) }}">
                            <i>{{ values.scientificName || values.value }}</i>
                        </a>
                        <i *ngIf="!values.alphaCode">{{ values.scientificName || values.value }}</i>
                        <label class="alphaCode" *ngIf="values.alphaCode">&nbsp;({{ alphaCodeLabel + ": " + values.alphaCode + "; " + values.name }})</label>

                    </li>
                </ul>
            </ng-container>
            <div class="mt-2">
                <a class="more" href="javascript:" *ngIf="!showMore" (click)="showMore=!showMore"><span>{{ configService.getTranslation('filterterms.showmore') }}</span></a>
                <a class="more" href="javascript:" *ngIf="showMore" (click)="showMore=!showMore"><span>{{ configService.getTranslation('filterterms.showless') }}</span></a>
            </div>
        </ng-container>
    </div>
</div>